module.exports = __webpack_public_path__ + "static/media/home-contracting-3@2x.ead98ef0.jpg";